import { css } from '@emotion/react'
import { PAGE_BREAKPOINTS } from 'parameters/index'
import styled from '@emotion/styled'

export interface GridContainerProps {
	articleCardHeight?: number
	articleCardWidth?: number
	columnCount?: number
}

const BaseGridContainer = css`
	display: grid;
	grid-row-gap: 2em;
	grid-column-gap: 2em;

	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		grid-row-gap: 1em;
		grid-column-gap: 1em;
	}
`

export const GridContainer = styled.div<GridContainerProps>`
	--grid-item-height: ${props => props.articleCardHeight || 435}px;
	--grid-item-width: ${props => props.articleCardWidth || 290}px;
	--grid-max-columns: ${props => props.columnCount || 3};
	${BaseGridContainer};

	width: 100%;
	grid-auto-flow: row dense;
	grid-template-columns: repeat(var(--grid-max-columns), 1fr);
	grid-auto-rows: auto;
	grid-template-rows: auto;

	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		grid-template-columns: repeat(calc(var(--grid-max-columns) - 1), 1fr);
	}

	@media screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		grid-template-columns: repeat(1, 1fr);
	}
`
export const GridItem = styled.div`
	height: var(--grid-item-height);
	--card-body-min-height: 60%;
`
export const MasonryGridItem = styled(GridItem)`
	:nth-of-type(7n + 2),
	:nth-of-type(7n + 6) {
		grid-column: span 2;
		--card-body-min-height: 35%;
		@media screen and (${PAGE_BREAKPOINTS.MOBILE}) {
			grid-column: unset;
		}
	}
`

export const FullRow = styled.span`
	grid-column-start: 1;
	grid-column-end: -1;
`

export const ScrollableGridContainer = styled(GridContainer)`
	--grid-item-width: ${props => props.articleCardWidth || 290}px;
	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		grid-template-columns: unset;
		grid-auto-flow: column dense;
		grid-auto-columns: var(--grid-item-width);
		grid-template-rows: var(--grid-item-height);
	}
`
